import { trending } from "@/mocks/homeData";

const trendMeta: Record<string, { icon: string; label: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", label: "升温", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", label: "降温", className: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", label: "持平", className: "text-foreground-500" },
};

export default function TrendingSection() {
  return (
    <section id="trending" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="mb-8">
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.28em] text-primary-600">
            <i className="ri-fire-line" />
            今日热搜
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            大家今天都在看什么
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-x-12 gap-y-1 lg:grid-cols-2">
          {trending.map((item) => {
            const meta = trendMeta[item.trend];
            return (
              <a
                key={item.rank}
                href="#updates"
                className="group flex cursor-pointer items-center gap-4 border-b border-background-200 py-4"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-label text-sm ${
                    item.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex-1 truncate font-body text-sm text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                  {item.title}
                </span>
                <span className="hidden font-label text-xs text-foreground-500 sm:block">{item.heat}</span>
                <span className={`flex items-center gap-1 font-label text-xs ${meta.className}`}>
                  <i className={meta.icon} />
                  {meta.label}
                </span>
              </a>
            );
          })}
        </div>

        <p className="mt-6 font-body text-xs leading-relaxed text-foreground-500">
          热度按当天讨论量的相对变化估算，仅用于说明话题受关注的程度，不代表对事件的任何判断。
        </p>
      </div>
    </section>
  );
}